import type { CSSProperties } from 'react';

export type ShapeKind = 'triangle' | 'diamond' | 'circle' | 'square';

export const SHAPE_FOR_POS: ShapeKind[] = ['triangle', 'diamond', 'circle', 'square'];

interface Props {
  kind: ShapeKind;
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export function Shape({ kind, size = 40, className, style }: Props) {
  const s = size;
  const stroke = Math.max(2, Math.round(s * 0.08));

  if (kind === 'triangle') {
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 100 100"
        className={className}
        style={style}
        aria-hidden="true"
      >
        <polygon
          points="50,12 88,82 12,82"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (kind === 'diamond') {
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 100 100"
        className={className}
        style={style}
        aria-hidden="true"
      >
        <polygon
          points="50,8 92,50 50,92 8,50"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (kind === 'circle') {
    return (
      <svg
        width={s}
        height={s}
        viewBox="0 0 100 100"
        className={className}
        style={style}
        aria-hidden="true"
      >
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={stroke}
        />
      </svg>
    );
  }
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 100 100"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <rect
        x="12"
        y="12"
        width="76"
        height="76"
        rx="14"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinejoin="round"
      />
    </svg>
  );
}
